<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-center v-if="isLoading">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="title pa-3">{{ $t('searching_account') }}</div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center v-if="!isLoading">
      <v-flex xl4 lg6 md7 sm10 xs12>
        <v-list two-line class="br-10 elevation-3" dense>
          <v-subheader>
            <h3>{{ $t('user_profile') }}</h3>
            <v-spacer></v-spacer>
            <v-btn text @click="$router.push('/user/form')" color="primary">
              <v-icon class="mr-3">fa-pencil-square-o</v-icon>{{ $t('update') }}
            </v-btn>
          </v-subheader>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ data.full_name | uppercase }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('name', { field: '' }) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ data.ic_num }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('ic_num') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary lighten-2" class="pl-2">fa-envelope fa-lg</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ data.name }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('email_address') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary lighten-2" class="pl-2">fa-phone-square fa-lg</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ data.phone }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('phone_no') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- <v-list
          subheader
          two-line
          flat
          class="br-10 elevation-3 mt-5"
          dense
        >
          <v-subheader><h3>{{ $t('settings') }}</h3></v-subheader>
          <v-divider></v-divider>
          <v-list-item-group>
            <v-list-item @click="$router.push({ name: 'settings-communication' })">
              <template>
                <v-list-item-content>
                  <v-list-item-title>Communication</v-list-item-title>
                  <v-list-item-subtitle>e-Billing / Newsletter</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn no-ripple text color="primary">
                    <v-icon class="mr-3">fa-pencil-square-o</v-icon>{{ $t('update') }}
                  </v-btn>
                </v-list-item-action>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      isLoading: 'auth/isLoading'
    }),
    ...mapState({
      data: (state) => state.auth.data
    })
  },
  created: async function () {
    if (this.$store.getters['auth/hasName']) {
      await this.$store.dispatch('auth/fetchData')
    }
    const response = await this.$store.dispatch('auth/session')
    if (response.userCtx.name === '' || response.userCtx.name === 'couchdb' || !this.data) {
      this.$router.push('/')
      this.$store.dispatch('snackbar/setSnackBar', {
        color: 'error',
        message: 'Pengguna tidak dijumpai. Sila log masuk semula.',
        visible: true
      })
    }
  }
}
</script>
